import React from 'react';
import { useEntitlements } from '../context/EntitlementsContext';
import Button from 'react-bootstrap/Button';
// PMPro checkout deep links (adjust level IDs if yours differ)
const PMPRO_LEVEL_URLS = {
  monthly: '/membership-levels',
  yearly: '/membership-levels',
  lifetime: '/membership-levels',
};

export default function UpgradeBanner({
  needed = 'monthly',
  message = 'Unlock this feature by upgrading your plan.',
  setStep
}) {
  const ent = useEntitlements();
  if (!ent || ent.__loading) return null;

  const current = ent.plan; // 'demo' | 'monthly' | 'yearly' | 'lifetime'
  const levelUrl = PMPRO_LEVEL_URLS[needed] || PMPRO_LEVEL_URLS.yearly;
  console.log(current);
  // Hide banner if user already has equal/higher plan
  const rank = { demo: 0, monthly: 1, yearly: 2, lifetime: 3 };
  if ((rank[current] ?? 0) >= (rank[needed] ?? 1)) return null;

  return (
    <div style={{
      margin: '12px 0', padding: 12, borderRadius: 10,
      backdropFilter: 'blur(8px)', background: 'rgba(255,255,255,0.06)',
      border: '1px solid rgba(255,255,255,0.14)'
    }}>
      <strong>Upgrade Required</strong>
      <div style={{ opacity: 0.85, margin: "10px 0px 10px 0px" }}>{message}</div>
                  <div className="action-card glass tint-forest on-dark" style={{marginBottom: "10px"}}>
                    <p>
                      For data formats, use these as references for export for student information system output.
                    </p>
                    <p><a href="https://grade.academy/wp-content/uploads/2025/01/350_grades.csv">Grade Reference Data</a></p>
                    <p><a href="https://grade.academy/wp-content/uploads/2025/01/350_enrollment.csv">Enrollment Reference Data</a></p>
                  </div>
      <Button variant="secondary" onClick={() => setStep(1)}>
            Back
        </Button>
      <Button
        href={levelUrl}
        variant="secondary"
        className="m-2">
        Upgrade to Continue
      </Button>
    </div>
  );
}
